import { render } from "./farmStaySubNavBar.vue?vue&type=template&id=6e13c598"
const script = {}

import "./farmStaySubNavBar.vue?vue&type=style&index=0&id=6e13c598&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__